<template>
    <section>
        <div v-if="response.status == 'warning'">
            <div class="alert bg-orange color-palette alert-dismissible pl-2 pr-4">
                <button type="button" class="close px-2" data-dismiss="alert" aria-hidden="true">×</button>
                <h4 class="loading"><b><i class="icon fa fa-clock-o"></i></b> Aguarde</h4>
                &nbsp; Estamos validando seus dados
            </div>
        </div>
        <div v-if="response.status == 'error'" class="alert alert-danger alert-dismissible pl-2 pr-4">
            <button type="button" class="close px-2" data-dismiss="alert" aria-hidden="true">×</button>
            <h4><i class="icon fa fa-exclamation-triangle"></i>Ops, ocorreu um erro..</h4>
            &nbsp; {{response.message}}
        </div>
        <div v-if="response.status == 'success'" class="alert alert-success alert-dismissible pl-2 pr-4">
            <button type="button" class="close px-2" data-dismiss="alert" aria-hidden="true">×</button>
            <h4><i class="icon fa fa-check"></i>Tudo pronto</h4>
            &nbsp; {{response.message}}
        </div>
    </section>
</template>

<script>
    export default {
        data() {
            return {
                response: {
                    status: 'warning',
                    message: 'Aguarde, estamos validando seus dados...'
                }
            }
        },
        watch: {
            $route(data) {
                this.$destroy();
            }
        },
        mounted() {
            switch (this.$route.name) {
                case 'confirmEmail':
                    this.confirmEmail();
                    break;
                case 'confirmarVinculo':
                    this.confirmVinculo();
                    break;
                default:
                    break
            }
        },
        methods: {
            confirmEmail() {
                this.$store.dispatch('confirmEmail', this.$route.params.tokenId)
                    .then(response => {
                        setTimeout(() => {
                            this.response = response;
                            this.$route.params.tokenId = null
                        }, 3000);
                    })
            },
            confirmVinculo() {
                this.message = 'Aguarde, estamos vinculando você ao cofre...';
                this.$store.dispatch('confirmVinculo', this.$route.params.tokenId).then(response => {
                    this.response = response;
                    this.$route.params.tokenId = null;
                });
            }
        }
    }
</script>

<style scoped>
    .loading:after {
        content: ' .';
        animation: dots 1s steps(5, end) infinite;
    }

    @keyframes dots {

        0%,
        20% {
            color: rgba(0, 0, 0, 0);
            text-shadow:
                .25em 0 0 rgba(0, 0, 0, 0),
                .5em 0 0 rgba(0, 0, 0, 0);
        }

        40% {
            color: white;
            text-shadow:
                .25em 0 0 rgba(0, 0, 0, 0),
                .5em 0 0 rgba(0, 0, 0, 0);
        }

        60% {
            text-shadow:
                .25em 0 0 white,
                .5em 0 0 rgba(0, 0, 0, 0);
        }

        80%,
        100% {
            text-shadow:
                .25em 0 0 white,
                .5em 0 0 white;
        }
    }
</style>